import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { getMyOrders } from '_redux/modules/order'
import { getMulListDeliveryCreatedByHost, getDeliveryByBuyer } from '_redux/modules/delivery'
import { getListCombinedPayment } from '_redux/modules/event'
import { convertTimeStringWithDuration } from '_utils/function'
import { getUserInfo } from '_utils/localData'
import { DELIVERY_OPENED } from '_utils/constant'

const now = moment().unix()

const usePurchaseData = () => {
  const dispatch = useDispatch()

  const userInfo = getUserInfo()
  const { id: userId } = userInfo || {}

  const [isLoading, setIsLoading] = useState(false)
  const [isShowModal, setIsShowModal] = useState(false)
  const [deliveryInfo, setDeliveryInfo] = useState(null)

  const {
    myOrders,
    listHostId,
    listHostDetail } = useSelector((state) => state.order)

  const { listDeliveryCreatedByHost, listDeliveryByBuyer } = useSelector((state) => state.delivery)

  const initialOrders = async () => {
    setIsLoading(true)
    await dispatch(getMyOrders)
    if (userId) {
      await dispatch(getDeliveryByBuyer(userId))
    }
    setIsLoading(false)
  }

  const initListCombined = async (_myOrders, _listDeliveryByBuyer) => {
    const listCombinedPaymentRef = []

    if (_myOrders && _myOrders.length) {
      _myOrders.forEach((element) => {
        const { combinedPaymentRef = '' } = element
        if (combinedPaymentRef && !listCombinedPaymentRef.includes(combinedPaymentRef)) {
          listCombinedPaymentRef.push(combinedPaymentRef)
        }
      })
    }

    if (_listDeliveryByBuyer && _listDeliveryByBuyer.length) {
      _listDeliveryByBuyer.forEach((element) => {
        const { combinedPaymentRef = '' } = element
        if (combinedPaymentRef && !listCombinedPaymentRef.includes(combinedPaymentRef)) {
          listCombinedPaymentRef.push(combinedPaymentRef)
        }
      })
    }

    if (listCombinedPaymentRef.length) {
      await dispatch(getListCombinedPayment(listCombinedPaymentRef))
    }
  }

  const addDelivery = async (hostId, groupId) => {
    const hostDelivery = listDeliveryCreatedByHost?.find((item) => item.hostId === hostId)
    if (!hostDelivery) return

    let { listDeliveryCreated } = hostDelivery
    if (!listDeliveryCreated || !listDeliveryCreated.length) return

    const { deliveryZones } = listDeliveryCreated[0]
    const hostDetail = listHostDetail?.find((item) => item.eCreatedUserId === hostId) || {}
    const { eCreatedUserName, eCreatedUserPhotoUrl } = hostDetail

    listDeliveryCreated = listDeliveryCreated
      .sort((a, b) => b.deliveryTimestamp - a.deliveryTimestamp)
      .filter((item) => item.groupId === groupId
        && item.deliveryStatus === DELIVERY_OPENED
        && item.deliveryTimestamp > now)
      .map((item) => ({
        ...item,
        deliveryTime: convertTimeStringWithDuration(item.deliveryTime, item.deliveryDuration)
      }))

    setDeliveryInfo({
      deliveryZones,
      listDeliveryCreated,
      eCreatedUserName,
      eCreatedUserPhotoUrl,
    })
    setIsShowModal(true)
  }

  useEffect(() => {
    initListCombined(myOrders, listDeliveryByBuyer)
  }, [myOrders, listDeliveryByBuyer])

  useEffect(() => {
    initialOrders()
  }, [])

  const getListDeliveryCreatedByHost = async (_listHostId) => {
    if (_listHostId && _listHostId.length) {
      await dispatch(getMulListDeliveryCreatedByHost(_listHostId))
    }
  }

  useEffect(() => {
    getListDeliveryCreatedByHost(listHostId)
  }, [listHostId])

  return {
    isLoading,
    isShowModal,
    setIsShowModal,
    deliveryInfo,
    setDeliveryInfo,
    myOrders,
    listHostId,
    listHostDetail,
    listDeliveryCreatedByHost,
    listDeliveryByBuyer,
    addDelivery
  }
}

export default usePurchaseData
